import React from 'react'
import t from '../../../i18n/login'

const ImgCode = props => {
    const {
        isImgLoadingOn, imgCode, imgCodeSrc, imgCodeError,
        // codeCheck,
        onImgCodeChange, onImgCodeBlur, onImgCodeFresh,
     } = props
    let codeDom = null
    if (imgCodeError) {
        codeDom = <p className="oc-err">{imgCodeError}</p>
    }
    // else if (codeCheck ) {
    //     codeDom = <p className="oc-err oc-err-check">{codeCheck}</p>
    // }

    return (
        <div className="oc-inp">
            <div className="oc-inpbox oc-inpbox-code">
                <input className="oc-inptxt" type="text" placeholder={t('imgcode_tips')} maxLength="4" value={imgCode} onChange={(e) => onImgCodeChange(e)} onBlur={() => onImgCodeBlur()}/>
            </div>
            {codeDom}
            <a className="btn-oc btn-oc-code">
            { !isImgLoadingOn
                ? (imgCodeSrc ? <img src={imgCodeSrc} onClick={() => onImgCodeFresh()} /> : null)
                : <span className="oc-loading-gif"><img src="/images/purchase/loading.gif" /></span>
            }
            </a>
        </div>
    )
}

export default ImgCode



// WEBPACK FOOTER //
// ./js/src/pages/Login/components/ImgCode.jsx